<template>
  <v-container class="pt-0">
    <v-row>
      <v-col class="mx-0 px-0 pt-0">
        <header-text-bg :site="site" text="historyCoupon" />
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12" sm="10" md="8">
        <v-slide-group class="py-0" center-active mandatory show-arrows>
          <!-- Slot ปุ่มกดฝั่งซ้าย (Prev) -->
          <template v-slot:prev="{ on, attrs }">
            <v-btn
              icon
              fab
              x-small
              v-bind="attrs"
              v-on="on"
              class="custom-slide-btn"
            >
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
          </template>

          <!-- Slot ปุ่มกดฝั่งขวา (Next) -->
          <template v-slot:next="{ on, attrs }">
            <v-btn
              icon
              fab
              x-small
              v-bind="attrs"
              v-on="on"
              class="custom-slide-btn"
            >
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </template>

          <v-slide-item
            v-for="cate in categoryList"
            :key="cate.id"
            v-slot="{ active, toggle }"
            @change="initialize(cate)"
          >
            <v-card
              rounded="lg"
              class="px-2 mx-1"
              @click="toggle"
              elevation="0"
              width="15%"
              :style="
                active
                  ? { border: '1.5px solid', 'border-color': site.color }
                  : ''
              "
            >
              <v-container class="pa-0">
                <v-col class="d-flex justify-center pt-2 pb-0">
                  <v-icon :color="site.color">{{ `mdi-${cate.icon}` }}</v-icon>
                </v-col>
                <p style="font-size: 12px" class="text-center mb-0">
                  {{ cate.label }}
                </p>
              </v-container>
            </v-card>
          </v-slide-item>
        </v-slide-group>
      </v-col>
    </v-row>

    <v-container fluid>
      <v-row class="mt-2">
        <v-col
          class="px-1"
          cols="12"
          v-for="(item, index) in list"
          :key="index"
          @click="item.is_repeat_view && showData(item)"
          :style="{
            cursor: item.is_repeat_view ? 'pointer' : 'not-allowed',
            opacity: item.is_repeat_view ? 1 : 0.5,
          }"
        >
          <v-sheet outlined :color="site.color" rounded>
            <v-card elevation="0">
              <v-list-item three-line>
                <v-list-item-content>
                  <v-list-item-title
                    class="text-body-2 mb-1"
                    v-snip="{ lines: 1 }"
                  >
                    {{ item.name }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <div
                      v-if="
                        Array.isArray(item.point_used) &&
                        item.point_used.length > 0
                      "
                      class="d-flex align-center"
                      style="gap: 4px"
                      :style="{ color: site.color }"
                    >
                      <PointSymbol
                        :type="item.point_used[0].point_type_type"
                        :symbol="item.point_used[0].point_type_symbol"
                        :color="item.point_used[0].point_type_color"
                        :is_display="true"
                        :outlined_box="false"
                        :size="20"
                      />
                      {{ item.point_used[0].point | commaPoint }}
                      {{ item.point_used[0].point_type_name }}
                    </div>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    {{ item.date_used | checkExpire }}
                  </v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-avatar size="70" tile :color="site.color">
                  <v-img :src="item.image_url"></v-img
                ></v-list-item-avatar>
              </v-list-item>
            </v-card>
          </v-sheet>
        </v-col>
      </v-row>
      <div v-if="!list.length">
        <v-col class="d-flex justify-center mt-16">
          <v-img
            class="white--text mx-auto mt-10 empty"
            :src="require('@/assets/images/out-of-stock.png')"
            max-width="150px"
          >
          </v-img>
        </v-col>
        <p class="text-center">{{ $t("errDataNotFound") }}</p>
      </div>
    </v-container>

    <CouponDialog
      :dialog="dialogCoupon"
      :data="dataDialog"
      :color="site.color"
      :displayTypes="dataDialog.display_type"
      @close="closeDialog()"
    />

    <div>
      <infinite-loading @infinite="infiniteHandler" :identifier="infiniteId">
        <div slot="spinner"></div>
        <div slot="no-more"></div>
        <div slot="no-results"></div>
      </infinite-loading>
    </div>
  </v-container>
</template>

<script>
import Axios from "@/config/customer-service";
import InfiniteLoading from "vue-infinite-loading";
import { mapState } from "vuex";
import headerTextBg from "../../../components/headerTextBg.vue";
import moment from "moment";
import CouponDialog from "../MyCoupons/component/DialogCoupon.vue";
import PointSymbol from "../../../components/point/point-symbol.vue";

export default {
  name: "HistoryMyCoupon",
  inject: ["isAppLoading"],
  components: { headerTextBg, InfiniteLoading, CouponDialog, PointSymbol },
  data() {
    return {
      page: 1,
      infiniteId: 0,
      list: [],
      next_page_url: "",
      categoryList: [],
      category: "all",
      dialogCoupon: false,
      dataDialog: {},
    };
  },
  created() {
    this.getCategory();
  },
  methods: {
    getCategory() {
      Axios.get("reward/listRewardCategory").then(({ data }) => {
        if (data.status == "success") {
          let cate = data.data;
          cate.map((item) => {
            this.categoryList.push({
              icon: item.icon,
              label: item.label,
              value: item.category,
            });
          });
          this.categoryList.unshift({
            icon: "order-bool-ascending",
            label: this.$t("categoryAll"),
            value: "all",
          });
        }
      });
    },
    initialize(cate) {
      this.isAppLoading(true);
      this.list = [];
      this.next_page_url = "";
      this.infiniteId += 1;
      this.category = cate ? cate.value : "all";
    },
    infiniteHandler($state) {
      Axios.get("reward/myCoupon", {
        params: {
          category: this.category,
          cursor: this.next_page_url,
          type: "used",
        },
      })
        .then(({ data }) => {
          if (data.data.data.length) {
            let has_more = data.data.has_more;
            this.list = this.list.concat(data.data.data);
            if (!has_more) {
              $state.complete();
              return;
            }
            this.next_page_url = data.data.next_page_url.split("=")[1];
            $state.loaded();
          } else {
            $state.complete();
          }
        })
        .finally(() => {
          this.isAppLoading(false);
        });
    },
    showData(item) {
      this.dataDialog = item;
      this.dialogCoupon = true;
    },
    closeDialog() {
      this.dataDialog = {};
      this.dialogCoupon = false;
    },
  },
  computed: {
    ...mapState("defaultSystem", ["site"]),
  },
  filters: {
    checkExpire(value) {
      if (!value) return "-";
      const date = moment(value);
      let label = "";
      if (date.year() == moment().year()) {
        label = date.format("DD MMM, HH:mm");
      } else {
        label = date.format("DD MMM YY, HH:mm");
      }
      return label;
    },
    commaPoint(value) {
      // comma point number to baht
      if (value == 0) {
        return "0";
      } else if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
  },
};
</script>

<style scoped>
.custom-slide-btn {
  background-color: #ffffff !important;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.15) !important;
  transition: all 0.2s ease-in-out;
}

.custom-slide-btn:hover {
  background-color: #f5f5f5 !important;
  transform: scale(1.08);
}

.custom-slide-btn .v-icon {
  color: #333333 !important;
}
</style>
